export const mapAsyncFlatten = async (array: any[], asyncFunction: (x: any) => any) => {
  const noflatArray = await Promise.all(array.map(asyncFunction));
  return noflatArray.flat()
}

export const toArray = (value: any) => {
  return Array.isArray(value) ? value : [value]
}